import { render, staticRenderFns } from "./WidgetEditProductModal.vue?vue&type=template&id=72b57f25"
import script from "./WidgetEditProductModal.vue?vue&type=script&lang=js"
export * from "./WidgetEditProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports